import { useSettings } from "../../../../context";
import { ContentWrapper, SliderIcon, SliderWrapper } from "./styled";
import Slider from "../../../../../../../../library/slider";
import { getIcon } from "../../../../../../../../utils/get-icon";

const BorderWidthConfiguration = () => {
  const { getSelectedItemSettings, updateStrokeSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  if (currentSettings?.type !== "text") {
    return null;
  }

  const handleWidthChange = (value: number | number[]) => {
    const val = Array.isArray(value) ? value[0] : value;
    if (!isNaN(val)) {
      updateStrokeSettings({ width: val });
    }
  };

  return (
    <ContentWrapper>
      <SliderWrapper>
        <SliderIcon>{getIcon("font")}</SliderIcon>
        <Slider
          min={0}
          max={360}
          value={currentSettings?.configuration.stroke?.width ?? 0}
          onChange={handleWidthChange}
          dots={false}
        />
      </SliderWrapper>
    </ContentWrapper>
  );
};

export default BorderWidthConfiguration;
